var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c("div", [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm" }),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-8" }, [
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.data.startpage.bulletList) }
              }),
              _vm._v(" "),
              !_vm.isPhone
                ? _c("div", { staticClass: "clearfix--mid" })
                : _vm._e(),
              _vm._v(" "),
              _vm.isPhone
                ? _c("div", [
                    _c("button", {
                      staticClass: "btn btn-primary btn-md btn-pulse",
                      staticStyle: { "min-width": "150px" },
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.data.startpage.healthAnalysisBtnText
                        )
                      },
                      on: {
                        click: function($event) {
                          return _vm.$router.push("/scr-s")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _c("button", {
                      staticClass: "btn btn-primary btn-md",
                      staticStyle: { "min-width": "150px" },
                      domProps: {
                        innerHTML: _vm._s(_vm.data.startpage.referralBtnText)
                      },
                      on: {
                        click: function($event) {
                          return _vm.$router.push("/scr-r")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.imgsLoaded,
                      expression: "!imgsLoaded"
                    }
                  ],
                  staticClass: "row",
                  class: !_vm.isPhone ? "row-imgs" : ""
                },
                [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.imgsLoaded,
                      expression: "imgsLoaded"
                    }
                  ],
                  staticClass: "row",
                  class: !_vm.isPhone ? "row-imgs" : ""
                },
                [
                  _c("div", { staticClass: "col-sm-3" }, [
                    _c("img", {
                      staticClass: "img-thumbnail img-responsive",
                      attrs: {
                        src: require("@/assets/img/gallery/" +
                          _vm.img1 +
                          ".jpg"),
                        alt: "Gallery image"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-5" }, [
                    _c("img", {
                      staticClass: "img-thumbnail img-responsive",
                      attrs: {
                        src: require("@/assets/img/gallery/" +
                          _vm.img2 +
                          ".jpg"),
                        alt: "Gallery image"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-3" }, [
                    _c("img", {
                      staticClass: "img-thumbnail img-responsive",
                      attrs: {
                        src: require("@/assets/img/gallery/" +
                          _vm.img3 +
                          ".jpg"),
                        alt: "Gallery image"
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              !_vm.isPhone
                ? _c("div", { staticClass: "clearfix--mid" })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isPhone
                ? _c("button", {
                    staticClass: "btn btn-primary btn-md btn-pulse",
                    staticStyle: { "min-width": "150px" },
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.data.startpage.healthAnalysisBtnText
                      )
                    },
                    on: {
                      click: function($event) {
                        return _vm.$router.push("/scr-s")
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isPhone
                ? _c("div", { staticClass: "clearfix--mid" })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isPhone
                ? _c("button", {
                    staticClass: "btn btn-primary btn-md",
                    staticStyle: { "min-width": "150px" },
                    domProps: {
                      innerHTML: _vm._s(_vm.data.startpage.referralBtnText)
                    },
                    on: {
                      click: function($event) {
                        return _vm.$router.push("/scr-r")
                      }
                    }
                  })
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm" })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-lg col-middle" }, [
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.data.startpage.orderedList) }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm" }),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-5" }, [
              _c("div", {
                domProps: {
                  innerHTML: _vm._s(_vm.data.startpage.loginBelowText)
                }
              }),
              _vm._v(" "),
              _c("button", {
                staticClass: "btn btn-primary btn-md",
                staticStyle: { "min-width": "150px" },
                domProps: {
                  innerHTML: _vm._s(_vm.data.startpage.loginResultsBtnText)
                },
                on: {
                  click: function($event) {
                    return _vm.$router.push("/login-tr")
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
              _vm._v(" "),
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.data.startpage.asteriskText) }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm" })
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-3" }, [
      _c("img", {
        staticClass: "img-thumbnail img-responsive",
        attrs: { src: "https://via.placeholder.com/300?text=...", alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-5" }, [
      _c("img", {
        staticClass: "img-thumbnail img-responsive",
        attrs: { src: "https://via.placeholder.com/300?text=...", alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-3" }, [
      _c("img", {
        staticClass: "img-thumbnail img-responsive",
        attrs: { src: "https://via.placeholder.com/300?text=...", alt: "" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b2ebd71", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b2ebd71","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Startpage.vue
// module id = null
// module chunks = 